import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const VendorPolicy = () => {
  document.title = "Vendor Policy | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">
              <h1 className="mt-4 mb-4">Vendor Policy</h1>
              {/* INTRO */}
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>This Vendor Policy defines the rules, responsibilities, and expectations for all sellers on <strong>MordenBazaar</strong>.</li>
                <li>By registering as a vendor, you agree to comply with all policies listed below.</li>
                <li>Failure to follow these policies may result in suspension or termination.</li>
              </ul>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Vendor Eligibility</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Vendors must be legally eligible to sell products in India.</li>
                <li>Valid PAN, GST (if applicable), and bank details are mandatory.</li>
                <li>MordenBazaar reserves the right to approve or reject vendor applications.</li>
                <li>Providing false or misleading information may lead to suspension.</li>
              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. Product Listings & Quality Standards</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>All product details must be accurate, complete, and transparent.</li>
                <li>Product images must be original and reflect the actual product.</li>
                <li>Misleading descriptions or fake images are strictly prohibited.</li>
                <li>Repeated quality complaints may result in listing removal.</li>
              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. Prohibited & Restricted Products</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Alcohol, liquor, tobacco, cigarettes, vapes, or intoxicating substances.</li>
                <li>Drugs, narcotics, psychotropic substances, or illegal medicines.</li>
                <li>Prescription medicines or medical products without authorization.</li>
                <li>Weapons, firearms, ammunition, explosives, or sharp objects.</li>
                <li>Counterfeit, fake, pirated, or replica products.</li>
                <li>Adult, pornographic, obscene, or sexually explicit items.</li>
                <li>Gambling, betting, lottery, or illegal gaming products.</li>
                <li>Hazardous, flammable, toxic, or radioactive materials.</li>
                <li>Products promoting violence, hate, or illegal activities.</li>
                <li>Any item prohibited under Indian laws or regulations.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. Pricing & Commissions</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Vendors are responsible for setting correct product prices.</li>
                <li>MordenBazaar may charge a commission on each successful order.</li>
                <li>Commission details will be shared via vendor dashboard.</li>
                <li>Fake discounts or price manipulation are not allowed.</li>
              </ul>

              {/* 5 */}
              <h2 className="mt-5 mb-3">5. Order Processing & Shipping</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Orders must be processed within the defined SLA timelines.</li>
                <li>Products must be packed securely to prevent damage.</li>
                <li>Incorrect or delayed shipments may attract penalties.</li>
                <li>Repeated delays may impact vendor ratings.</li>
              </ul>

              {/* 6 */}
              <h2 className="mt-5 mb-3">6. Returns, Refunds & Disputes</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Vendors must comply with MordenBazaar return and refund policies.</li>
                <li>Refund amounts may be deducted from future settlements.</li>
                <li>Disputes will be reviewed internally by MordenBazaar.</li>
                <li>MordenBazaar’s decision in disputes will be final.</li>
              </ul>

              {/* 7 */}
              <h2 className="mt-5 mb-3">7. Vendor Payments & Settlements</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Vendor payouts are processed after successful delivery.</li>
                <li>Settlement cycles may be weekly or bi-weekly.</li>
                <li>Applicable taxes, commissions, or penalties may be deducted.</li>
                <li>Accurate bank details are mandatory for payouts.</li>
              </ul>

              {/* 8 */}
              <h2 className="mt-5 mb-3">8. Legal & Policy Compliance</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Vendors must comply with all applicable laws.</li>
                <li>Intellectual property violations are strictly prohibited.</li>
                <li>Fraudulent activity may lead to immediate suspension.</li>
              </ul>

              {/* 9 */}
              <h2 className="mt-5 mb-3">9. Suspension or Termination</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>MordenBazaar may suspend or terminate vendor accounts.</li>
                <li>Reasons include policy violations or repeated complaints.</li>
                <li>Serious violations may result in permanent termination.</li>
              </ul>

              {/* 10 */}
              <h2 className="mt-5 mb-3">10. Policy Updates</h2>
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>This policy may be updated from time to time.</li>
                <li>Major changes will be communicated via email or dashboard.</li>
                <li>Continued use of the platform implies acceptance of updates.</li>
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default VendorPolicy;
